import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { peformanceGoalListRequest } from '../../../redux/performance/peformance.action'
import moment from "moment";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";

const PerformanceGoalList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { state } = useLocation()
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { peformanceGoalListSuccess, peformanceGoalListError } = useSelector(state => state.peformance)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const TAB_LIST = [
        'ALL', `${new Date().getFullYear()}`
    ]
    const [selectedTab, setSelectedTab] = useState(TAB_LIST[0])

    useEffect(() => {
        if (state?.isFromMenu) {
            if (isLoggedInUserBusiness(user)) {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.PERFORMANCE_GOAL_LIST, true)
                fetchBusinessList()
            } else if (isLoggedInUserEmployee(user)) {
                fetchGoalList()
            }
        } else {
            fetchGoalList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchGoalList = (reviewYear = null) => {
        setLoading(true)
        const data = {}
        if (state?.isFromMenu) {
            if (isLoggedInUserBusiness(user) && !isEmpty(selectedBusiness) && !isEmpty(selectedLocation)) {
                data.businessId = selectedBusiness.businessId
                data.locationId = selectedLocation.locationId
            }
            if (isLoggedInUserEmployee(user) && !isEmpty(employeeSelectedBusiness) && !isEmpty(employeeSelectedLocation)) {
                data.businessId = employeeSelectedBusiness
                data.locationId = employeeSelectedLocation
            }
            data.employeeId = isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId
            data.employeeUserType = user.data.userDetails.userType
        } else {
            data.businessId = state.businessId
            data.locationId = state.locationId
            data.employeeId = state.employeeId
            data.employeeUserType = state.userType
        }
        if (!isEmpty(reviewYear)) {
            data.reviewYear = reviewYear
        }
        dispatch(peformanceGoalListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.PERFORMANCE_GOAL_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.PERFORMANCE_GOAL_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(peformanceGoalListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(peformanceGoalListError)) {
            setLoading(false)
        }
    }, [peformanceGoalListSuccess, peformanceGoalListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchGoalList()
        }
    }, [selectedLocation])

    const handleAddGoalClick = () => {
        navigate(ROUTES.performance.newGoal)
    }

    const handleTabSelect = (item) => {
        setSelectedTab((prevTab) => {
            fetchGoalList(item === TAB_LIST[0] ? null : item)
            return item
        })
    }

    const getStatusClassname = (status) => {
        if (status === APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.NEW) {
            return 'pd-status-container pd-status-container-new'
        } else if (status === APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.IN_PROGRESS) {
            return 'pd-status-container pd-status-container-in-progress'
        } else if (status === APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.COMPLETED) {
            return 'pd-status-container pd-status-container-complete'
        } else if (status === APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.ON_HOLD) {
            return 'pd-status-container pd-status-container-hold'
        }
    }

    const handleViewDetailClick = (item) => {
        navigate(ROUTES.performance.goalDetail, { state: item.performanceGoalId })
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Goals' />
                {state?.isFromMenu && isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                <div className="al-tab-row-container">
                    <div
                        className={`al-row-item-container ${selectedTab === TAB_LIST[0] ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_LIST[0]) }}>{TAB_LIST[0]}</div>
                    <div
                        className={`al-row-item-container ${selectedTab === TAB_LIST[1] ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_LIST[1]) }}>{TAB_LIST[1]}</div>
                </div>
                {!isEmpty(peformanceGoalListSuccess) && !isEmpty(peformanceGoalListSuccess.data) && <div className="pgl-row-container">
                    {peformanceGoalListSuccess.data.map(item => (<div className="pgl-row-item-container">
                        <div className={getStatusClassname(item.status)}>{removeSpecialCharAndChangeToPascal(item.status)}</div>
                        <h6 className="pgl-goal-year">{item.reviewYear}</h6>
                        <h5 className="pgl-goal-title">{item.title}</h5>
                        <p className="pgl-goal-description">{item.description}</p>
                        <p>Due Date: {moment.utc(item.endDate).local().format('DD/MM/YYYY')}</p>
                        <div className="pgl-button-container">
                            <div className="tr-action-btn" onClick={() => { handleViewDetailClick(item) }}>View Details</div>
                        </div>
                    </div>))}
                </div>}
                {!isEmpty(peformanceGoalListError) && <div className="content-error">{peformanceGoalListError.message}</div>}
                {state?.isFromMenu && <div className="vl-fab-container" onClick={() => handleAddGoalClick()}>
                    <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default PerformanceGoalList